/**
 * Copyright (c) 2026 Constructor Technology AG. All rights reserved.
 *
 * Proprietary and confidential. Unauthorized copying, distribution, or use
 * is prohibited.
 *
 * SPDX-License-Identifier: LicenseRef-Constructor-Proprietary
 */

import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import state from './state'

export default {
  actions,
  getters,
  mutations,
  namespaced: true,
  state,
}
